import { Box, Group, Stack, Text } from '@mantine/core';
import type { Shema } from '../api/odjemalec';
import { casIzMs } from '../oblika/oblika';
import { barve } from '../tema';

type Sporocilo = Shema['PovratnoSporocilo'];

/**
 * Sporočila povratne informacije kot pogovor (najstarejše zgoraj). Sporočila, za katera {@code desno} vrne true, so
 * na desni v barvi izbire (pri stranki njena, v skrbništvu odgovori skrbništva), ostala levo na sivi podlagi.
 */
export function Pogovor({ sporocila, desno }: { sporocila: Sporocilo[]; desno: (s: Sporocilo) => boolean }) {
  return (
    <Stack gap="sm" role="list" aria-label="Sporočila">
      {sporocila.map((s) => {
        const d = desno(s);
        return (
          <Box
            key={s.id}
            role="listitem"
            maw={{ base: '92%', sm: '80%' }}
            ml={d ? 'auto' : 0}
            px="md"
            py="sm"
            style={{
              background: d ? barve.izbrano : barve.povrsinaPolje,
              border: `1px solid ${s.skrbnik ? barve.primarna : barve.obroba}`,
              borderRadius: 12,
            }}
          >
            <Group justify="space-between" gap="xs" mb={4} wrap="wrap">
              <Text size="sm" fw={700} c={s.skrbnik ? 'hera' : undefined}>
                {s.avtor}
              </Text>
              <Text size="xs" c="dimmed">
                {casIzMs(s.cas)}
              </Text>
            </Group>
            <Text size="sm" style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>
              {s.besedilo}
            </Text>
          </Box>
        );
      })}
    </Stack>
  );
}
